import { createRoute } from '@tanstack/react-router';
import { IconTruck } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { DRIVERS, PLACES, ROUTES, TRIPS, VEHICLES } from './fixtures';
import { FleetPage } from './FleetPage';
import { RoutesPage } from './RoutesPage';
import { ROUTE_ROWS } from './routes';
import { WAREHOUSES } from './warehouses';
import { PlacesPage } from './PlacesPage';
import { DispatchPage } from './DispatchPage';
import { TmsPage } from './TmsPage';
import { TripDetailPage } from './TripDetailPage';
import { DutyPhonePage } from './DutyPhone';
import { RoutePricePage } from './RoutePricePage';

const tms: EzyModule = {
  // Nhóm "Vận tải" theo NAV KIT (Mint-TMS); các mục còn lại của nhóm thêm khi có màn.
  nav: { key: 'vt', label: 'Vận tải', icon: IconTruck, items: [{ key: 'tms', label: 'Điều độ', to: '/ezy/tms' }, { key: 'dispatch', label: 'Lưới điều xe', to: '/ezy/tms/dispatch' }, { key: 'routes', label: 'Tuyến', to: '/ezy/tms/routes' }, { key: 'places', label: 'Bản đồ điểm & tuyến', to: '/ezy/tms/places' }, { key: 'fleet', label: 'Đội xe & danh mục', to: '/ezy/tms/fleet' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/tms', component: TmsPage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/dispatch', component: DispatchPage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/fleet', component: FleetPage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/places', component: PlacesPage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/routes', component: RoutesPage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/routes/price', component: RoutePricePage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/duty', component: DutyPhonePage }),
    createRoute({ getParentRoute: () => parent, path: '/tms/trips/$tripId', component: TripDetailPage }),
  ],
  fixtures: (register) => {
    register('trip', TRIPS);
    register('vehicle', VEHICLES);
    register('driver', DRIVERS);
    register('tmsPlace', [...PLACES, ...WAREHOUSES]);
    register('tmsRoute', ROUTES);
    register('tmsRouteRow', ROUTE_ROWS);
  },
};
export default tms;
